import 'ag-grid-enterprise/dist/ag-grid-enterprise.js';
import './reference-data-criteria-component.scss';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import moment from 'moment';

import {
  faCopy,
  faFileExport,
  faPlus,
  faSave,
  faSync,
  faTrash,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import { inject, observer } from 'mobx-react';

import AgGrid from '../../../common/components/ag-grid/ag-grid';
import { AppConstants } from '../../../common/APIConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ReferenceDataGridOptions from './reference-data-grid-options';
import RestEndPoint from '../../../common/RestEndPoint';
import { render } from "react-dom";
import commonstore from '../../../common/commonstore';

@inject('ReferenceDataStore')
@observer
class ReferenceData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rowSelected: false,
      gridOptions: ReferenceDataGridOptions(),
      newRowNotSaved:false,
      filterModel:null,
      fileNameExcel:null,
      viewProfile: null,
    };
  }
  getDigMasterWarningMessage(screenTitle) {
    return screenTitle === "Dig Master Tracker" ?
      <h5 className="warning-message"> Warning:  Do not make changes or create any new entries
      </h5> : null
  }
  render() {
    const {
      screen: { title, canEditRow, canCopyRow, canDeleteRow }, exportProfiles
    } = this.getCurrentScreen();
    const {
      columnDefinitions,
      rowData,
      rowDataFetched,
      saveBtnText,
      addRowBtnText,
      selectedData,
      exportBtnText,
      refreshBtnText,
      deleteBtnText,
      copyBtnText
    } = this.props.ReferenceDataStore;
    const { rowSelected, gridOptions } = this.state;
    //let newRowPresent=rowData.find(x=>x.isNewRow)?true:false;
    let colDef = [...columnDefinitions];
    colDef.splice(0, 0,({
        field:'Action',
        headerName: "action",
                width: 140,
                cellRenderer: 'actionCellRenderer',
                editable: false,
                colId: "action",
                pinned: 'left',
               onCellClicked: this.onCellClicked.bind(this)
    }));
    return (
      <>
        <div className="container cb-title-container">
          <h3 className="cb-title">{title}</h3>
          {this.getDigMasterWarningMessage(title)}
        </div>
        <div className="col-md-12">
          {rowDataFetched && (
            <>
              <div className="row">
                <AgGrid
                  gridOptions={gridOptions}
                  columnDefs={colDef}
                  rowData={rowData}
                  onSelectionChanged={this.onSelectionChanged}
                 onCellValueChanged={this.onCellValueChanged.bind(this)}
                 onFilterChanged={this.onFilterChanged}
                 rememberGroupStateWhenNewData={true} 
                />
              </div>
              <div className="row btn-toolbar pull-right">
                {canEditRow  && (
                  <button
                    type="button"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={this.state.newRowNotSaved}
                    onClick={this.addNewRow}
                  >
                    <FontAwesomeIcon icon={faPlus} /> {addRowBtnText}
                  </button>
                )}
                {/* {canEditRow && (
                  <button
                    type="button"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={!selectedData.length}
                    onClick={this.saveData}
                  >
                    <FontAwesomeIcon icon={faSave} /> {saveBtnText}
                  </button>
                )} */}
                {canDeleteRow && (
                  <button
                    type="button"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={!rowSelected}
                    onClick={this.deleteRecord}
                  >
                    <FontAwesomeIcon icon={faTrash} /> {deleteBtnText}
                  </button>
                )}
                {canCopyRow && (
                  <button
                    type="button"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={!rowSelected || this.state.newRowNotSaved}
                    onClick={this.copyRecord}
                  >
                    <FontAwesomeIcon icon={faCopy} /> {copyBtnText}
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.exportToExcel}
                >
                  <FontAwesomeIcon icon={faFileExport} /> {exportBtnText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.refreshData}
                >
                  <FontAwesomeIcon icon={faSync} /> {refreshBtnText}
                </button>
              </div>
              {exportProfiles && (exportProfiles.length >0) &&
              <div className="row btn-toolbar pull-left customExportPnl">
                 {this.getExportButtons(exportProfiles)}
              </div>}
            </>
          )}
        </div>
      </>
    );
  }

  componentDidMount = async () => {
    await this.refreshData();
  };
  onFilterChanged(params) {
    let sortModel = params.columnApi.filterModel;
    this.setState({filterModel: sortModel});
  }
  refreshData = async () => {
    this.setState({newRowNotSaved:false});
    this.setState({ rowSelected: false, fileNameExcel:null  });
    await this.getGridData();
    
  };
  getExportButtons = (exportProfiles) => {
    return exportProfiles.map((profile) => {
      return <button className="btn btn-primary btn-grid active custom-exportButtons" onClick={()=>this.customExport(profile)} > <FontAwesomeIcon icon={faEye} className="customExport-icn" />{profile.name}</button>
    })
  }
  switchView(profile)
  {
    if(profile)
    {
      this.setState({viewProfile: profile});
    var items = profile.columns.split(/\s*,\s*/);
    const keys = this.state.gridOptions.columnApi.getAllDisplayedColumns().filter(x => items.indexOf(x.colId) < 0)
        .map(column => column.getColId());
    keys.forEach((col) => {
      if(col!=='action')
      {
      this.state.gridOptions.columnApi.setColumnVisible(col, false) ;
      }
    });
    }
  }
  customExport = async(profile) =>
  {
    await this.refreshData();
    const currentScreen = this.getCurrentScreen();
    var today = new Date();
    const formattedDate = moment(today).format('YYYYMMDDhhmmss');
    const currentSheet =currentScreen.screen.title.split(' ').join('_');
    const fileNameExcel= currentSheet+'_Export_'+profile.rowKey+'_'+formattedDate+'';
    this.setState({fileNameExcel: fileNameExcel});
    //const columnsToExport =this.generateColumnsForCustomExcel(profile);
    const switchView = this.switchView(profile);
  }
  getLabel =(refLookupData, selectedValue)=>
  {
      if(refLookupData && refLookupData.lookupValues.values && selectedValue && refLookupData.lookupValues.values.find(x=>x.value===selectedValue) )
     return refLookupData.lookupValues.values.find(x=>x.value===selectedValue).label;
     else  return null;
  }
  generateColumnsForCustomExcel(profile)
  {
    if(profile)
    {
    var items = profile.columns.split(/\s*,\s*/);
    const keys = this.state.gridOptions.columnApi.getAllDisplayedColumns().filter(x => items.indexOf(x.colId) > -1)
        .map(column => column.getColId());
    return keys;
    }
    else 
    {
    const columns= this.state.gridOptions.columnApi.getAllDisplayedColumns().map(column => column.getColId());
    const columnstoExport= [...columns];
    return columnstoExport.filter(x=>x!='action');
    }
  }

  getCurrentScreen = () => {
    const screenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );

    return currentScreen;
  };

  getKeyColumnName = () => {
    const { screenColumns } = this.getCurrentScreen();
    const keyColumn = screenColumns.find((x) => x.isKey);
    let keyColumnName = keyColumn ? keyColumn.name : 'id';

    return keyColumnName;
  };

  getGridData = async () => {
    const { CommonStore, ReferenceDataStore } = this.props;
    const currentScreen = this.getCurrentScreen();

    try {
      CommonStore.toggleLoader();
      await ReferenceDataStore.getGridData(currentScreen);

      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
    }
  };

  addNewRow = async () => {
    this.setState({newRowNotSaved:true});
    const keyColumnName = this.getKeyColumnName();
    let rowCount = this.state.gridOptions.api.getDisplayedRowCount();
    let newRowData = {};

    this.props.ReferenceDataStore.columnDefinitions.forEach((col) => {
      newRowData[col.field] = null;
    });

    newRowData.isNewRow = true;
    newRowData[keyColumnName] = ++rowCount;

    this.state.gridOptions.api.insertItemsAtIndex(0, [newRowData]);
    let cols = this.state.gridOptions.columnApi.getAllDisplayedColumns();
    const NonPinnedColumn= cols.filter(x=>!x.pinned);
    this.state.gridOptions.api.ensureColumnVisible(NonPinnedColumn[0] );
    this.state.gridOptions.api.startEditingCell({
      rowIndex:0,
      // gets the first columnKey
      colKey: this.state.gridOptions.columnApi.getDisplayedCenterColumns()[0].colId
    });
    this.state.gridOptions.api.ensureColumnVisible(NonPinnedColumn[0] );
    this.selectNode(0);
  };
 


  onCellClicked(params) {
    if (params.column.colId === "action" && params.event.target.dataset.action) {
      let action = params.event.target.dataset.action;
      if (action === "edit") {
     
        let cols = params.columnApi.getAllGridColumns().filter(col=>typeof col.colDef.editable=="function"?
        col.colDef.editable(params):col.colDef.editable);
      let firstCol = {
          "colId": ""
      }
      if (cols) {
          firstCol = cols[0];
                
      }
        let rowIndex = params.node.rowIndex;
        params.api.ensureColumnVisible(firstCol );
      params.api.setFocusedCell(rowIndex, firstCol);      
        params.api.startEditingCell({
          rowIndex: params.node.rowIndex,
          // gets the first columnKey
          colKey: params.colDef.colId
        });
      }
      if (action === "update") {
        const keyColumnName = this.getKeyColumnName();      
        this.saveRowData(params, keyColumnName);       
        params.api.stopEditing(true);
      
      }

      if (action === "cancel") {
        const keyColumnName = this.getKeyColumnName();
     const {rowData} = this.props.ReferenceDataStore;
        params.api.stopEditing(true);
      }
      let cols = params.columnApi.getAllDisplayedColumns();
      const NonPinnedColumn= cols.filter(x=>!x.pinned);
      params.api.ensureColumnVisible(NonPinnedColumn[0] );
    }}

  filterItems= async( filters)=> {
    let rowData = [];
    this.state.gridOptions.api.forEachNode(node => rowData.push(node.data));
    return rowData.filter(function(val) {
      for(let i = 0; i < filters.length; i++)
      {
        const k= 'test';
        if(val[filters[i][0]] != filters[i][1])
          return false;
      }
      return true;
      
    });
  }

  saveRowData=async (params, keyColumnName) => {
    this.setState({filterModel:this.state.gridOptions.api.getFilterModel()});
    const { CommonStore, ReferenceDataStore } = this.props;
    const currentScreen = this.getCurrentScreen();
    const screenData={};
    const dataVal= Object.assign(screenData, params.node.data);
    //Required Validation 
    const requiredColumns= currentScreen.screenColumns.filter(x=>x.required);
    let requiredValidated=true;
    for (let col of requiredColumns) {
      if(!dataVal[col.name])
      {
       requiredValidated= false;
       break;
      }
    }
    if(!requiredValidated)
    {
      window.toastr.error(AppConstants.TOASTER_ERROR_REQUIRED_TEXT);
    }
    else{
      let IsDuplicate=false;
       //duplicate validation
    const {duplicateCheckRequired, columnsForDuplicate}= currentScreen.screen;
    if(duplicateCheckRequired && columnsForDuplicate)
    {
    const duplicateRows= await this.duplicateCheck(columnsForDuplicate, dataVal);
    IsDuplicate = duplicateRows.length >1?true:false;
    }
    if(IsDuplicate)
    {
      window.toastr.error(AppConstants.TOASTER_ERROR_DUPLICATE_TEXT );
    }else {
      if(dataVal["isNewRow"])
      {
        this.setState({newRowNotSaved:false});
      }
    CommonStore.toggleLoader();
    

    var responseData= await ReferenceDataStore.saveRowData(currentScreen, dataVal);

    this.onSaveSuccess();
    }
    }
  }
  duplicateCheck=async(columnsForDuplicate,dataVal) =>
  {
    var duplicateModel = [];
    var items = columnsForDuplicate.split(/\s*,\s*/);
    items.forEach((col) => {
      duplicateModel.push([col,dataVal[col] ]);
     });
   const duplicateValue=await this.filterItems( duplicateModel);
   return duplicateValue;
  }
  saveData = async () => {
    const { CommonStore, ReferenceDataStore } = this.props;
    const currentScreen = this.getCurrentScreen();

    CommonStore.toggleLoader();

    await ReferenceDataStore.saveData(currentScreen);

    this.onSaveSuccess();
  };
executeDelete = async (currentScreen, selectedRow) => {
  const { CommonStore, ReferenceDataStore } = this.props;
  CommonStore.toggleLoader();

  await ReferenceDataStore.deleteData(currentScreen, selectedRow);
        
  this.onSaveSuccess();
};
  deleteRecord = async () => {
    const { CommonStore, ReferenceDataStore } = this.props;
    const currentScreen = this.getCurrentScreen();
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    confirmAlert({
      title: 'Delete Confirmation',
      message: 'Are you sure, you want to delete the selected record?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {this.executeDelete(currentScreen, selectedRow);}
        },
        {
          label: 'No',
          onClick: () => {return false;}
        }
      ]
    });
    
  };

  
  copyRecord = async () => {
    const keyColumnName = this.getKeyColumnName();
    let rowCount = this.state.gridOptions.api.getDisplayedRowCount();
    let newRowData = this.state.gridOptions.api.getSelectedRows()[0];
    const rowObj={};
    const rowToCopy= Object.assign(rowObj, newRowData);
    const { screenColumns } = this.getCurrentScreen();
    const keyColumn = screenColumns.filter((x) => x.toRemoveOnCopy);
    
    keyColumn.forEach((col) => {
      rowToCopy[col.name] = null;
     });

     rowToCopy.isNewRow = true;
     rowToCopy[keyColumnName] = ++rowCount;

    this.state.gridOptions.api.insertItemsAtIndex(0, [rowToCopy]);
    let cols = this.state.gridOptions.columnApi.getAllDisplayedColumns();
    this.state.gridOptions.api.ensureColumnVisible(cols[1] );
    this.state.gridOptions.api.startEditingCell({
      rowIndex:0,
      // gets the first columnKey
      colKey: this.state.gridOptions.columnApi.getDisplayedCenterColumns()[0].colId
    });
    this.setState({newRowNotSaved:true});
    const NonPinnedColumn= cols.filter(x=>!x.pinned);
    this.state.gridOptions.api.ensureColumnVisible(NonPinnedColumn[0] );
    this.selectNode(0);
  }
  selectNode(nodeIndex)
  {
    let node = this.state.gridOptions.api.getDisplayedRowAtIndex(0);
    node.setSelected(true);
  }
  
  lookupKey(mappings, name) {
    let valueItem;
    for (valueItem in mappings) {
        if (mappings.hasOwnProperty(valueItem)) {
            if (name === mappings[valueItem].label) {
                return mappings[valueItem].value;
            }
        }
    }
  }
  onCellValueChanged  = function (e) {
    const { selectedData } = this.props.ReferenceDataStore;
    const keyColumnName = this.getKeyColumnName();

    if (e.newValue !== null && e.oldValue !== e.newValue) {
      this.populateAuditFields(e.data);

      const existingRowIndex = selectedData.findIndex(
        (x) => x[keyColumnName] === e.data[keyColumnName]
      );

      if (existingRowIndex > -1) {
        selectedData[existingRowIndex] = e.data;
      } else {
        selectedData.push(e.data);
      }
      this.state.gridOptions.api.refreshCells();
    }
    else {
      e.node.setDataValue(e.colDef.field, e.oldValue);
      
    }
  };

  onSelectionChanged = async (e) => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    this.setState({ rowSelected: selectedRow.length });
  };

  populateAuditFields(data) {
    const currentUser = RestEndPoint.getCurrentUserName();

    if ('CreatedBy' in data && data["isNewRow"]) {
      data['CreatedBy'] = currentUser;
    }
    if ('UpdatedBy' in data) {
      data['UpdatedBy'] = currentUser;
    }
    if ('CreatedOn' in data  && data["isNewRow"]) {
      data['CreatedOn'] = new Date();
    }
    if ('IsActive' in data  && data["isNewRow"]) {
      data['IsActive'] = true;
    }
    if ('UpdatedOn' in data) {
      data['UpdatedOn'] = new Date();
    }
  }

  exportToExcel =  () => {
    const { screen } = this.getCurrentScreen();
    const {CommonStore} =this.props;
    const {fileNameExcel} = this.state;
    
    let params = {
      allColumns: false,
      onlySelected: false,
      onlySelectedAllPages: false,
      shouldRowBeSkipped: false,
      skipFooters: false,
      skipGroups: true,
      skipHeader: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      fileName: screen.name
    };
    const currentScreen = this.getCurrentScreen();
    var today = new Date();
    const formattedDate = moment(today).format('YYYYMMDDhhmmss');
    const currentSheet =currentScreen.screen.title.split(' ').join('_');
    let fileNameExcelExport= currentSheet+'_Export_All_'+formattedDate+'';
    if(fileNameExcel)
    {
      fileNameExcelExport= fileNameExcel;
    }
   
     this.state.gridOptions.api.exportDataAsExcel({
      fileName:fileNameExcelExport,
      sheetName: currentSheet,
      columnKeys: this.generateColumnsForCustomExcel(),
      processCellCallback: function (params) {
        if (params.column.colDef.cellEditor==="SmartSelect") {
          
          const refLookupData= currentScreen.screenColumns.find(x=>x.name===params.column.colId).refLookupData;
          const selectedValue= params.value;
          if(refLookupData && refLookupData.lookupValues.values && selectedValue && refLookupData.lookupValues.values.find(x=>x.value===selectedValue) )
          return refLookupData.lookupValues.values.find(x=>x.value===selectedValue).label;
          else  return null;
        }
        return params.value;
      }
      
    })
    
  };

  onSaveSuccess() {
    const { CommonStore } = this.props;
   
    const filterModel=this.state.gridOptions.api?this.state.gridOptions.api.getFilterModel():null;
    this.setState({filterModel});
    let columnGroupState = this.state.gridOptions.columnApi?.getColumnGroupState();
    CommonStore.toggleLoader();
    const savedState =this.state.gridOptions.columnApi.getColumnState(); 
    this.refreshData().then(() =>
    {if (filterModel) {
      this.state.gridOptions.api.setFilterModel(null);
      this.state.gridOptions.api.setFilterModel(filterModel);
      this.state.gridOptions.api.onFilterChanged();
      this.state.gridOptions.columnApi.setColumnState(savedState );
    }}).then(() =>{});

  }
}

export default ReferenceData;
